import { create } from "zustand";
import { immer } from "zustand/middleware/immer";
import type { IParking } from "../apis/parkingbeesRelatedService/type";

type TGeneralStore = {
  isLoading: boolean;
  setIsLoading: (state: boolean) => void;
  parkingListWithEvCharger?: IParking[];
  setParkingListWithEvCharger: (list: IParking[]) => void;
};

const initState = {
  isLoading: false,
  parkingListWithEvCharger: [],
};

const useGeneralStore = create<TGeneralStore>()(
  immer((set) => ({
    ...initState,
    setIsLoading: (isLoading: boolean) => set({ isLoading }),
    setParkingListWithEvCharger: (list: IParking[]) =>
      set((state) => {
        state.parkingListWithEvCharger = list;
      }),
  }))
);

export default useGeneralStore;
